import { v4 as uuidv4 } from "uuid";

import Sentry from "@similarweb/sentry-logger";

import { DefaultFetchService } from "app/services/fetchService";

// Headers are inlined here (rather than imported from a shared module) because this
// runs at the very earliest stage of the app lifecycle, before app modules are wired up.
const ApiHeaders = {
    "X-Sw-Page": location.href,
    "X-Sw-Page-View-Id": uuidv4(),
};

export const initGoogleTag = async (): Promise<void> => {
    try {
        const gtm = await DefaultFetchService.getInstance().get("api/googletag", {}, { headers: ApiHeaders });
        if (!gtm) {
            return;
        }
        (window as unknown as { GTM: unknown }).GTM = gtm;
        // Notifies inline tracker scripts in templates/partials/{gtm,matomo,ga4Tag}.html
        document.dispatchEvent(new CustomEvent("GTMReady"));
    } catch (e: unknown) {
        // GTM is non-critical analytics — log and continue so the app still loads.
        const error = e instanceof Error ? e : new Error(String(e));
        console.error("error in api/googletag", error);
        Sentry.error("error in api/googletag", error);
    }
};
